import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../hooks/useKeyPress';
import BodyContentView from '../views/bodyContentView';
import {useMenu} from '../../hooks/useMenu';
import CommandsContext from '../../context/commandsContext';

function Configuration({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, setSelected, setList, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    setList(selected.children);
    setSelected(selected.children[0]);
    onComponent(null);
    onExit();
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onRight, onExit]);

  return (
    <BodyContentView
      title="-- WARNING --"
      left="No"
      right="Yes"
      caption="Changing configuration can affect transmitter operation.  Control loop should be set for manual operation
      Continue?"
    />
  );
}

export default Configuration;
